import DataNotFound from "@/components/data-not-found/DataNotFound";
import Spinner from "@/components/spinner/Spinner";
import useGetApiReq from "@/hooks/useGetApiReq";
import { useEffect, useState } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import ReactPaginate from "react-paginate";
import PartnerWrapper from "@/partner/components/wrapper/Wrapper";
import ServiceRequestComp from "@/partner/components/service-request-comp/ServiceRequestComp";

const ServiceRequest = () => {
  const { res, fetchData, isLoading } = useGetApiReq();

  const [allRequests, setAllRequests] = useState([]);
  const [status, setStatus] = useState("all");
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const limit = import.meta.env.VITE_LIMIT;

  const getServiceRequests = async () => {
    fetchData(
      `/partner/get-all-requests?page=${page}&limit=${limit}&status=${status === "all" ? "" : status}`,
    );
  };

  useEffect(() => {
    getServiceRequests();
  }, [page, status]);

  useEffect(() => {
    if (res?.status === 200 || res?.status === 201) {
      setAllRequests(res?.data?.requests);
      const count = Math.ceil(res?.data?.count / limit);
      setPageCount(count);
    }
  }, [res]);

  return (
    <PartnerWrapper>
      <div>
        <div className="section-heading-container">
          <h1 className="section-heading">Requests</h1>
        </div>

        <div className="flex gap-3 items-center mt-3">
          <button
            onClick={() => setStatus("all")}
            className={`px-2 py-1 rounded-md ${
              status !== "all"
                ? "bg-transparent border border-[#1A56DB] text-[#1A56DB]"
                : "bg-gray-800 text-white"
            }`}
          >
            All
          </button>
          <button
            onClick={() => setStatus("pending")}
            className={`px-2 py-1 rounded-md ${
              status !== "pending"
                ? "bg-transparent border border-[#1A56DB] text-[#1A56DB]"
                : "bg-orange-400 text-white"
            }`}
          >
            Pending
          </button>
          <button
            onClick={() => setStatus("accepted")}
            className={`px-2 py-1 rounded-md ${
              status !== "accepted"
                ? "bg-transparent border border-[#1A56DB] text-[#1A56DB]"
                : "bg-green-400 text-white"
            }`}
          >
            Accepted
          </button>
          <button
            onClick={() => setStatus("quotation-sent")}
            className={`px-2 py-1 rounded-md ${
              status !== "quotation-sent"
                ? "bg-transparent border border-[#1A56DB] text-[#1A56DB]"
                : "bg-yellow-500 text-white"
            }`}
          >
            Quotation-sent
          </button>
        </div>

        <div className="">
          <Table className="mt-4 glass-header !border-white !border-2">
            <TableHeader>
              <TableRow className="text-lg">
                <TableHead>Service Id</TableHead>
                <TableHead>Client Name</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading ? (
                <TableRow className="glass-header !border-white !border-2">
                  <TableCell colSpan={6} className="text-center py-4">
                    Loading...
                  </TableCell>
                </TableRow>
              ) : allRequests.length === 0 ? (
                <TableRow className="glass-header !border-white !border-2">
                  <TableCell colSpan={6}>
                    <DataNotFound name={"Services"} />
                  </TableCell>
                </TableRow>
              ) : (
                allRequests?.map((request) => (
                  <ServiceRequestComp
                    key={request._id}
                    serviceRequest={request}
                    getServiceRequests={getServiceRequests}
                  />
                ))
              )}
              {/* {allRequests?.map((request) => (
                <ServiceRequestComp
                  key={request._id}
                  serviceRequest={request}
                  getServiceRequests={getServiceRequests}
                />
              ))} */}
            </TableBody>
          </Table>
          {/* {allRequests.length === 0 && isLoading && <Spinner size={30} />}

          {allRequests.length === 0 && !isLoading && (
            <DataNotFound name={"Requests"} />
          )} */}
        </div>

        {pageCount > 0 && (
          <div className="mt-10 mb-5">
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              pageCount={pageCount}
              onPageChange={(e) => setPage(e.selected + 1)}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        )}
      </div>
    </PartnerWrapper>
  );
};

export default ServiceRequest;
